import "./arcade.css"

export default function Arcade(props) {


  return (
    <div
      class="arcade-container"
    >
      <div
        class="arcade-header"
      >
        <h1>Nic's Arcade</h1>
      </div>

      <div
        class="arcade-grid"
      >
        <div
          class="arcade-grid-a"
        >
          <h3>
            <a href="/rock-paper-scissors">
              Rock Paper Scissors
            </a>
          </h3>

          <div>
            Made using react, javascript, and css, for just fun!
          </div>
        </div>

        <div
          class="arcade-grid-b"
        >
          <h3>
            <a 
              target="_blank"
              rel="noreferrer"
              href="https://nicgauer.github.io/mm-devbuild/">
              Untitled Puzzle Game
            </a>
          </h3>

          <div>
            Alpha project made using Unity, Ableton, and Friendship for Blue Bug Game Studios.  
            Practice project for future games.  Link leads to in-progress development build.
          </div>
        </div>
        
      </div>
      {/* Arcade Works! */}
    </div>
  )
}